<template>
  <div class="serviceHall">
    <Carousel :bannerImg="bannerImg" :bannerInfo="bannerInfo" />
    <!-- 分类 -->
    <div class="w tabs flex">
      <div
        :class="['bon', index == tabIdx ? 'click_sty' : '']"
        v-for="(item, index) in tabList"
        :key="index"
        @click="tabChange(index,item.id)"
      >
        {{ item.targetName }}办事
      </div>
    </div>
    <div class="box_serv w">
      <div class="box_serv_l">
        <div class="search_dept">
          <a-input-search
            placeholder="请输入你要查询的关键字..."
            :maxLength="30"
            :allowClear="true"
            @search="getfindDepartment"
          />
        </div>
        <div class="dept_ul">
          <div class="dept_li" v-for="(item,idx) in department" :key="item.id" @click="deptChange(item.id, idx)">
            <div :class="[idx == deptIdx ? 'dept_name_select':'']">
              <a-tooltip placement="right" class="flex" style="justify-content: space-between;">
                <template slot="title">
                  <span>{{ item.name }}</span>
                </template>
                <div class="dept_name ellipsis">{{ item.name }}</div>
                <a-icon v-if="idx == deptIdx" type="arrow-right" />
              </a-tooltip>
              
            </div>
          </div>
        </div>
      </div>
      <div class="box_serv_r">
        <!-- 分类 -->
        <div class="service_class">
          <div class="cls_top">
            <div class="cls_le">服务主题</div>
            <div :class="['flex', 'cls_ct', ifShow2 ? 'cls_ct2' : 'cls_ct1']">
              <div
                :class="['cls_box', index == classIdx2 ? 'cls_box_bg' : '']" style="margin-bottom: 9px;"
                v-for="(item, index) in serviceClassify"
                :key="item.id"
                @click="serviceChange(item.id, index)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="cls_rt" :style="serviceClassify.length > 7?'':'visibility: hidden'" @click="changeIfShow(ifShow2, 2)">
              <span :style="ifShow2 ? 'color: var(--themeColor);' : ''">{{
                ifShow2 ? "收起" : "更多"
              }}</span>
              <img
                v-if="!ifShow2"
                src="../../assets/icon/icon-triangle-open-gary.png"
                alt=""
              />
              <img
                v-else
                src="../../assets/icon/icon-triangle-close-blue.png"
                alt=""
              />
            </div>
          </div>
          <div class="cls_top">
            <div class="cls_le">其他分类</div>
            <div :class="['flex', 'cls_ct', ifShow ? 'cls_ct2' : 'cls_ct1']">
              <div
                :class="['cls_box', index == classIdx ? 'cls_box_bg' : '']"
                v-for="(item, index) in othersList"
                :key="item.code"
                @click="othersSelect(item.code,index)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="service_ti flex">
          <div class="flex">
            <div class="title">共 <span class="total">{{ pagination.total }}</span> 个事项</div>
            <a-checkbox style="color: #7A8BA4;" @change="checkChange">可线上办理</a-checkbox>
          </div>
          <div>
            <a-input-search
              style="width: 299px; margin-left: 20px"
              placeholder="请输入你要查询的关键字..."
              enter-button
              :maxLength="30"
              :allowClear="true"
              @search="onSearch"
            />
          </div>
        </div>
    
        <!-- 表格 -->
        <div style="margin-bottom: 130px" v-if="list.length > 0">
          <a-table
            :columns="columns"
            :data-source="list"
            :loading="loading"
            rowKey="id"
            :pagination="pagination"
            @change="pageChange"
          >
            <template slot="serviceManageName" slot-scope="scope, row">
              <div class="flex table">
                <div class="ellipsis">{{ scope }}</div>
                <div class="table_name bg_green" v-if="row.priority == '1'">上新</div>
                <div class="table_name bg_yel" v-if="row.priority == '2'">荐</div>
                <div class="table_name bg_red" v-if="row.isLimitTime">限时</div>
                <div v-if="row.priority == '3'">
                  <img src="../../assets//icon/icon_top.png" alt="">
                </div>
              </div>
            </template>
            <template slot="serviceClassifyName" slot-scope="scope">
              <a-space>
                <div v-for="item in scope" :key="item">{{ item }}</div>
              </a-space>
            </template>
            <template slot="manageType" slot-scope="scope">{{
              scope == 1 ? "办事类" : "应用类"
            }}</template>
            <template slot="terminal" slot-scope="scope,row">
              <div v-if="row.isApply != 0">
                <img
                  v-if="scope != 1"
                  src="../../assets/icon-mobile-outline.png"
                  alt=""
                />
                <img v-if="scope != 2" src="../../assets/icon-pc-outline.png" alt="" />
              </div>
              <div v-else>无</div>
            </template>
            <template slot="operation" slot-scope="scope, row">
              <div class="flex">
                <div class="bon_l" @click="gotoDetails(row)">查看详情</div>
                <div :class="[row.isApply?'bon_r':'disable_class']" @click="gotoWork(row.isApply,row.pcUrl)">{{row.isApply?'线上办理':'线下办理'}}</div>
              </div>
            </template>
          </a-table>
        </div>
    
        <!-- 无数据 -->
        <img
          v-else
          style="margin-bottom: 120px"
          src="../../assets/no-date-red.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "事项名称",
    dataIndex: "serviceManageName",
    scopedSlots: { customRender: "serviceManageName" },
    width:250
  },
  {
    title: "主管部门",
    dataIndex: "deptName",
    scopedSlots: { customRender: "deptName" },
    width:250,
    ellipsis: true,
  },
  {
    title: "服务主题",
    dataIndex: "serviceClassifyName",
    width:200,
    scopedSlots: { customRender: "serviceClassifyName" },
  },
  // {
  //   title: "事项类型",
  //   dataIndex: "manageType",
  //   scopedSlots: { customRender: "manageType" },
  //   width:100
  // },
  {
    title: "服务终端",
    dataIndex: "terminal",
    scopedSlots: { customRender: "terminal" },
    width:80
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    width:200
  },
];
import {
  findServiceManageApi,
  findDepartmentApi,
  findServiceClassifyApi,
  findTargetsApi,
  findNavBannerApi,
  usageLogsApi
} from "@/api/index";
import imgPrefix from "../../../utils/imgPrefix";
import Carousel from "../../components/Carousel.vue";
export default {
  props: {},
  components: { Carousel },
  data() {
    return {
      loading: false,
      tabList: [],
      tabIdx: 0,
      checkbox: [],
      ifShow: 0,
      ifShow2: 0,
      checkList: [
        { label: "全部", value: "0" },
        { label: "上新事项", value: "1" },
        { label: "推荐事项", value: "2" },
        { label: "限时事项", value: "3" },
      ],
      department: [],
      serviceClassify: [],
      classIdx: 0,
      classIdx2: 0,
      deptIdx: 0,
      page: 1,
      pageSize: 10,
      pagination: {
        total: 0,
        current: 1,
        showTotal: (total) => `当前有${total}条部门记录  显示 1~10条`,
      },
      columns,
      list: [],
      form: {},
      bannerImg: [],
      bannerInfo: {
        title: "服务大厅",
        desc: "业务主题集合专区，推进“一门式、一网式”校务服务模式，让师生少跑腿、好办事、办好一件事。",
      },
      imgPrefix,
      othersList: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    // 获取服务对象
    findTargetsApi().then((res) => {
      // console.log(res);
      let data = res || []
      // if(data.length > 0){
      //   data = data.filter((item,idx) => idx < 4)
      // }
      this.tabList = data;
    });
    this.getfindDepartment()
    // 获取服务主题
    findServiceClassifyApi().then((res) => {
      console.log(res,'----------');
      res.topicsList.unshift({ id: "", name: "全部" });
      res.othersList.unshift({ id: "", name: "全部" });
      this.serviceClassify = res.topicsList || [];
      this.othersList = res.othersList || [];
    });
    this.getfindServiceManage();
    this.getBanner();
  },
  mounted() {},
  methods: {
    // 获取部门
    getfindDepartment(e){
      // console.log('部门查询',e);
      
      findDepartmentApi({keywords: e?e:''}).then((res) => {
        res.unshift({ id: "", name: "全部" });
        this.department = res;
      });
    },
    // 获取服务大厅列表数据
    getfindServiceManage() {
      let dto = Object.assign({}, this.form);
      dto.page = this.page;
      dto.pageSize = this.pageSize;
      this.loading = true;
      console.log(dto,'请求参数');
      findServiceManageApi(dto)
        .then((res) => {
          // console.log(res);
          this.list = res.voList.list;
          this.pagination.total = res.voList.total;
          this.pagination.current = res.voList.page;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },
    // 获取banner
    getBanner() {
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      if (naviTop) {
        naviTop.forEach((item) => {
          if (item.link == "/serviceHall") {
            findNavBannerApi(item.id)
              .then((res) => {
                // console.log(res);
                this.bannerImg = res;
              })
              .catch((err) => {
                this.$message.error(err.message);
              });
          }
        });
      }
    },
    tabChange(idx,id) {
      this.tabIdx = idx;
      this.$forceUpdate();
      // this.form.targets = `[${idx}]`;
      this.form.targets = idx==0?'':id;
      this.page = 1;
      this.getfindServiceManage();
    },
    onSearch(e) {
      // console.log(e);
      this.page = 1;
      this.form.keyword = e;
      this.getfindServiceManage();
    },
    checkChange(e){
      // console.log(e,'----------');
      this.form.isOnline = e.target.checked;
      this.getfindServiceManage();
    },
    // 选择其他分类
    othersSelect(code, idx){
      this.page = 1;
      this.classIdx = idx;
      this.form.others = code;
      this.getfindServiceManage();
    },
    // 切换部门
    deptChange(id, idx) {
      this.deptIdx = idx;
      this.form.deptId = id;
      this.page = 1;
      this.getfindServiceManage();
    },
    // 切换服务主题
    serviceChange(id, idx) {
      this.classIdx2 = idx;
      this.form.classifyId = id;
      this.page = 1;
      this.getfindServiceManage();
    },
    // 查看指南
    gotoDetails(e) {
      let dto = {
        "serviceId": e.id,
        "userId": "",
       }
       let userId = sessionStorage.getItem('userId');
       if(userId){
        dto.userId = userId;
       }
      usageLogsApi(dto).then(res => {})
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      let idx = "";
      if (naviTop) {
        naviTop.forEach((item, index) => {
          if (item.link == "/serviceHall") {
            idx = index;
          }
        });
      }
      this.$router.push(
        "/serviceDetails?index=" + idx + "&serviceManageId=" + e.id
      );
    },
    // 办理链接
    gotoWork(isApply,url) {
      if(isApply){
        window.open(url);
      }
    },
    changeIfShow(e, val) {
      if (val == 1) {
        this.ifShow = e == 0 ? 1 : 0;
      } else {
        this.ifShow2 = e == 0 ? 1 : 0;
      }
    },
    pageChange(pagination) {
      this.page = pagination.current;
      this.getfindServiceManage();
    },
  },
};
</script>

<style scoped lang="less">
.serviceHall {
  .tabs {
    margin-bottom: 18px;
    margin-top: 24px;
  }
  .title {
    font-size: 18px;
    color: #0d1c28;
    text-align: left;
    margin-right: 28px;
    .total {
      color: var(--themeSloganColor);
    }
  }
  .box_serv{
    display: flex;
    .box_serv_l{
      border-radius: 12px;
      background: #F9FBFE;
      padding: 18px 0;
      min-width: 214px;
      margin-right: 32px;
      height: 930px;
      .search_dept{
        padding: 0 24px;
      }
      .dept_ul{
        height: 94%;
        overflow-y: auto;
        margin-top: 32px;
        padding: 0 24px;
        .dept_li{
          margin-bottom: 32px;
          font-size: 16px;
          cursor: pointer;
          .dept_name{
            max-width: 200px;
            -webkit-line-clamp: 1;
          }
          .dept_name_select{
            color: var(--themeColor);
          }
          .flex{
            justify-content: space-between;
          }
        }
      }
    }
    .box_serv_r{
      .service_ti {
        align-items: center;
        justify-content: space-between;
        margin-top: 37px;
        margin-bottom: 18px;
      }
      .service_class {
        // background: #f7f8fb;
        border-radius: 8px;
        .cls_top {
          padding-bottom: 12px;
          padding-top: 10px;
          display: flex;
          border-bottom: 1px dashed #C6CDD8;
          .cls_box {
            padding: 4px 12px;
            margin-right: 32px;
            cursor: pointer;
            font-size: 14px;
          }
          .cls_box_bg {
            // background: rgba(8, 102, 180, 0.2);
            border: 1px solid var(--themeColor6);
            color: var(--themeColor);
            border-radius: 4px;
            
          }
          .cls_le {
            margin-right: 20px;
            min-width: 56px;
            line-height: 36px;
            color: #7a8ba4;
          }
          .cls_rt {
            flex: 1;
            cursor: pointer;
            line-height: 34px;
            color: #7a8ba4;
            img {
              margin-left: 14px;
            }
          }
          .cls_ct {
            overflow: hidden;
            flex-wrap: wrap;
            flex: 8;
          }
          .cls_ct1 {
            height: 36px;
          }
          .cls_ct2 {
            // height: 68px;
          }
        }
      }
      .table div {
        margin-right: 10px;
      }
      .table_name {
        color: #fff;
        font-size: 12px;
        padding: 0 3px;
        border-radius: 2px;
      }
    }
  }
  .ellipsis{
    max-width: 146px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .bg_red {
    background: #ff0000;
  }
  .bg_yel {
    background: #ff8C00;
  }
  .bg_green {
    border: 1px solid #00C800;
    color: #00C800 !important;
  }
  .icon_img {
    background: #f7f8fb;
    border-radius: 4px;
    padding: 6px 12px;
  }
  .bon_l {
    border: 1px solid var(--themeColor);
    border-radius: 8px;
    padding: 5px 7px;
    color: var(--themeColor);
    margin-right: 12px;
    cursor: pointer;
    text-align: center;
  }
  .bon_r {
    color: #fff;
    background: var(--themeColor);
    border-radius: 8px;
    padding: 6px 8px;
    cursor: pointer !important;
  }
  
  /deep/.ant-btn-primary {
    background: var(--themeColor);
  }
  /deep/.ant-table-pagination.ant-pagination {
    display: flex;
    float: none;
  }
  /deep/.ant-pagination-total-text {
    flex: 1;
    text-align: left;
    font-weight: 500;
    margin-left: 16px;
  }
  /deep/.ant-table-thead > tr > th {
    color: #7a8ba4;
  }
  /deep/.ant-table-thead > tr > th, 
  /deep/.ant-table-tbody > tr > td{
    padding: 16px 6px !important;
  }

  /* 自定义滚动条样式 */
  ::-webkit-scrollbar {
      width: 6px; /* 滚动条宽度 */
  }
  
  ::-webkit-scrollbar-thumb {
      background-color: darkgrey; /* 滚动条滑块颜色 */
      border-radius: 6px; /* 滑块圆角 */
  }
  
  ::-webkit-scrollbar-track {
      background-color: lightgrey; /* 滚动条轨道颜色 */
      border-radius: 6px; /* 轨道圆角 */
  }
}
</style>
